import { IQualificationModule, IQualification, IStudy, ResultStatus } from 'api-paths-cas';

/**
 * Currently we are only storing result status in the grouped qualification selections.
 * We need to identify the result status for each qualification based on its grouping.
 *
 * Ideally we wouldn't use this framework because its complicated, but we do not store this
 * information against the qualification directly.
 */
export function identifyResultStatusFromGrouping(
  studyGrouping: IStudy['qualificationTypeSelections'],
  qualification: IQualification | undefined,
): ResultStatus | null {
  if (!qualification) {
    console.warn('No qualification provided to identify result status');
    return null;
  }

  const qualificationRowId = qualification.qualificationTypeRowId;

  if (!studyGrouping || !Array.isArray(studyGrouping)) {
    console.warn('No study grouping available to identify result status');
    return null;
  }

  const matchingSelection = studyGrouping.find(selection => selection.id === qualificationRowId);

  if (!matchingSelection?.resultStatus) {
    console.warn('No matching selection or result status found for qualification', qualification);
    return null;
  }

  return matchingSelection.resultStatus;
}

export function getUniqueKeysFromObjects(object1: Record<string, unknown>, object2: Record<string, unknown>): string[] {
  let gaurdedObject1 = object1;
  let gaurdedObject2 = object2;

  if (!(object1 instanceof Object) || object1 instanceof Array) gaurdedObject1 = {}; // gaurd against incorrect typing
  if (!(object2 instanceof Object) || object2 instanceof Array) gaurdedObject2 = {};

  const keys1 = new Set(Object.keys(gaurdedObject1 || {}));
  const keys2 = new Set(Object.keys(gaurdedObject2 || {}));

  const allKeys = new Set<string>([...keys1, ...keys2]);

  return Array.from(allKeys);
}

export function getAllUniqueQualificationModuleIds(
  qualificationSubset1?: IQualificationModule[],
  qualificationSubset2?: IQualificationModule[],
): string[] {
  const moduleSet1 = new Set<string>();
  const moduleSet2 = new Set<string>();

  const values1 = qualificationSubset1 || [];
  const values2 = qualificationSubset2 || [];

  if (values1 instanceof Array) {
    for (const module of values1) {
      if (module) moduleSet1.add(`${module.subject}-${module.grade}`);
    }
  }

  if (values2 instanceof Array) {
    for (const module of values2) {
      if (module) moduleSet2.add(`${module.subject}-${module.grade}`);
    }
  }

  const allModuleIds = new Set<string>([...moduleSet1, ...moduleSet2]);

  return Array.from(allModuleIds);
}
